var staticStrFirst = 'first'

module.exports = staticStrFirst



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/staticStrFirst.js
// module id = 64
// module chunks = 98